const params = new URL(window.location.href).searchParams;
const addonParams = params.getAll("addon");

const loadingImageParam = params.get("loadingImage");
  window.loadingImageIndex = loadingImageParam !== null
    ? parseInt(loadingImageParam, 10)
    : null;



const hasEnabledAddon = addonParams.some(entry => {
    if (!entry) return false;

    const [_, rawValue = "0"] = entry.split("=");
    const enabledFlag = rawValue.split("_par_")[0];

    return Number(enabledFlag) === 1;
});


window.hideSkeleton = function () {
    setTimeout(function () {
        $(".pdp_skel-loading").hide();
        $('.pp_skeleton-media-outer').hide();
    }, 1000);
    $('.product-single__add-to-cart').removeClass('preloadActive');
};

if (!hasEnabledAddon) {
    $(".product-single").addClass("loadedVar");
    window.hideSkeleton();
}
else{
    $('.pp_skeleton-media-outer').addClass('bundleLoading');
    $('.pp_skeleton-main-bundle__loader[data-index="'+window.loadingImageIndex+'"]').removeClass('hided');
}

